<template>
  <th class="text-center">
    <v-dialog v-model="dialog" max-width="400px" content-class="rounded-xl">
      <template v-slot:activator="{ on }">
        <v-btn fab x-small text v-on="on">
          <v-icon small>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Фильтр коэффициента {{ cf_type }}</span>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-tabs dense centered icons-and-text>
          <v-tabs-slider></v-tabs-slider>
          <v-tab>
            Точное
            <v-icon left>mdi-bullseye-arrow</v-icon>
          </v-tab>
          <v-tab>
            Диапазон
            <v-icon left>mdi-swap-horizontal</v-icon>
          </v-tab>
          <v-tab>
            Список
            <v-icon left> mdi-format-list-bulleted</v-icon>
          </v-tab>
          <v-tab-item>
            <v-card flat id="exact-coef">
              <v-card-text>
                <v-text-field
                  label="Точное значение"
                  small
                  @input="$v.selected.$touch()"
                  :error-messages="exactErrors"
                  v-model="selected"
                ></v-text-field>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="this.$v.selected.$invalid || !this.selected"
                  class="success"
                  fab
                  small
                  right
                  @click="successClicked"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  fab
                  small
                  :disabled="!this.selected"
                  class="error"
                  right
                  @click="discardClickedExact"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card id="range-coef">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        label="Минимум"
                        required
                        @input="$v.min_selected.$touch()"
                        :error-messages="minErrors"
                        hint="Укажите минимальное значение коэффициента"
                        type="number"
                        v-model="min_selected"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Максимум"
                        @input="$v.max_selected.$touch()"
                        :error-messages="maxErrors"
                        hint="Укажите максимальное значение коэффициента"
                        type="number"
                        v-model="max_selected"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="text-center">
                <v-spacer></v-spacer>
                <v-btn
                  class="success"
                  :disabled="
                    this.$v.max_selected.$invalid ||
                    this.$v.min_selected.$invalid
                  "
                  right
                  fab
                  small
                  @click="successClickedRange"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  class="error"
                  :disabled="
                    (this.min_selected == 1 || this.min_selected == '') &&
                    (this.max_selected == 1000 || this.max_selected == '')
                  "
                  right
                  fab
                  small
                  @click="discardClickedRange"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card id="multiple-coef">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-combobox
                      v-model="selectedMultiple"
                      :filter="filter"
                      :hide-no-data="!search"
                      :items="items"
                      :search-input.sync="search"
                      :error-count="3"
                      :error-messages="[
                        'Числа должны быть больше 1.',
                        'Дробная часть отделяется точкой',
                        'В списке должно быть не меньше двух коэффициентов',
                      ]"
                      persistent-hint
                      hide-selected
                      label="Добавьте коэффициент"
                      multiple
                      small-chips
                      solo
                    >
                      <template
                        v-slot:selection="{ attrs, item, parent, selected }"
                      >
                        <v-chip
                          v-if="item === Object(item)"
                          v-bind="attrs"
                          color="green lighten-3"
                          :input-value="selected"
                          label
                          small
                        >
                          <span class="pr-2">
                            {{ item.text }}
                          </span>
                          <v-icon small @click="parent.selectItem(item)">
                            $delete
                          </v-icon>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ index, item }">
                        <v-text-field
                          v-if="editing === item"
                          v-model="editing.text"
                          autofocus
                          flat
                          background-color="transparent"
                          hide-details
                          solo
                          @keyup.enter="edit(index, item)"
                        ></v-text-field>
                        <v-chip
                          v-else
                          :color="`${item.color} lighten-3`"
                          dark
                          label
                          small
                        >
                          {{ item.text }}
                        </v-chip>
                        <v-spacer></v-spacer>
                        <v-list-item-action @click.stop>
                          <v-btn icon @click.stop.prevent="edit(index, item)">
                            <v-icon>{{
                              editing !== item ? "mdi-pencil" : "mdi-check"
                            }}</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </template>
                    </v-combobox>
                  </v-row>
                  <v-row>
                    <v-checkbox
                      label="Исключить эти значения"
                      v-model="checkbox"
                    ></v-checkbox>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="success"
                  fab
                  small
                  :disabled="this.selectedMultiple.length == 0"
                  right
                  @click="successClickedMultiple"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  class="error"
                  fab
                  :disabled="this.selectedMultiple.length == 0"
                  small
                  right
                  @click="discardClickedMultiple"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="success" @click="successClicked">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
        <!-- <v-btn class="error" @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { required, between } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    entity: {
      type: String,
      default: "",
    },
    cf_type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      selected: "",
      min_selected: "",
      max_selected: "",
      checkbox: false,
      selectedMultiple: [],
      activator: null,
      attach: null,
      editing: null,
      editingIndex: -1,
      items: [],
      nonce: 1,
      model: [],
      menu: false,
      x: 0,
      search: null,
      y: 0,
    };
  },
  mixins: [validationMixin],
  validations: {
    min_selected: {
      required,
      between: between(1, 1000),
    },
    max_selected: {
      required,
      between: between(1, 1000),
    },
    selected: {
      between: between(1, 1000),
    },
  },
  watch: {
    selectedMultiple(val, prev) {
      if (val.length === prev.length) return;

      this.selectedMultiple = val.map((v) => {
        if (typeof v === "string") {
          const isNum = !isNaN(v) && !isNaN(parseFloat(v)) && v >= 1;
          if (!isNum) return;
          // console.log("IsNum: " + isNum);
          v = {
            text: v,
            color: "green lighten3",
          };

          this.items.push(v);

          this.nonce++;
        }

        return v;
      });
    },
  },
  computed: {
    exactErrors() {
      const errors = [];
      if (!this.$v.selected.$dirty) return errors;
      const num_range = !this.$v.selected.between;
      num_range && errors.push("Число должно быть в диапазоне от 1 до 1000");
      return errors;
    },
    minErrors() {
      const errors = [];
      if (!this.$v.min_selected.$dirty) return errors;
      const num_range = !this.$v.min_selected.between;
      const num_required = !this.$v.min_selected.required;
      num_range && errors.push("Число должно быть в диапазоне от 1 до 1000");
      num_required && errors.push("Это обязательное поле");
      return errors;
    },
    maxErrors() {
      const errors = [];
      if (!this.$v.max_selected.$dirty) return errors;
      const num_range = !this.$v.max_selected.between;
      const num_required = !this.$v.max_selected.required;
      const more_than_min = this.min_selected >= this.max_selected;
      num_range && errors.push("Число должно быть в диапазоне от 1 до 1000");
      num_required && errors.push("Это обязательное поле");
      more_than_min &&
        errors.push("Максимальное должно быть больше минимального");
      return errors;
    },
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      // console.log("Changed: ");
    },
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.editingIndex = index;
      } else {
        this.editing = null;
        this.editingIndex = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    numberRule: (v) => {
      if (!v.trim()) return true;
      if (!isNaN(parseFloat(v)) && v >= 1 && v <= 100) return true;
      return "Число должно быть в диапазоне от 1 до 100";
    },
    successClicked: function () {
      // this.dialog = false;
      this.min_selected = 1;
      this.max_selected = 1000;
      this.selectedMultiple = [];

      var key_to_delete = this.entity + this.cf_type + "__range";
      this.cleanKey(key_to_delete);
      var lookup = this.checkbox ? "__not_in" : "__in";
      key_to_delete = this.entity + this.cf_type + lookup;
      // console.log("Deleting: " + key_to_delete);
      this.cleanKey(key_to_delete);

      let key = this.entity + this.cf_type;
      let value = this.selected;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
    },
    successClickedRange: function () {
      this.dialog = false;
      let key = this.entity + this.cf_type + "__range";
      let value = [this.min_selected || 1, this.max_selected || 1000];
      // console.log("Selected: " + value);
      this.selected = "";

      // :TODO: Think about it
      // var lookup = this.checkbox ? "__not_in" : "__in";
      // key_to_delete = this.entity + this.name + lookup;
      // console.log("Deleting: " + key_to_delete);
      // this.cleanKey(key_to_delete);
      let key_to_delete = this.entity + this.cf_type;
      // console.log("Key to delete:" + key_to_delete);
      this.cleanKey(key_to_delete);
      this.updateForm(key, value);
    },

    successClickedMultiple: function () {
      // First clean other filters to avoid conflicts
      this.dialog = false;
      this.selected = "";
      this.discardClickedRange();
      var lookup = this.checkbox ? "__not_in" : "__in";
      var negative_lookup = lookup == "__not_in" ? "__in" : "__not_in";
      var key_to_delete = this.entity + this.cf_type + negative_lookup;
      // console.log("Key to delete:" + key_to_delete);
      this.cleanKey(key_to_delete);
      key_to_delete = this.entity + this.cf_type;
      this.cleanKey(key_to_delete);
      // console.log("Selected: " + JSON.stringify(this.selectedMultiple));
      var value = [];
      for (const index in this.selectedMultiple) {
        // console.log("FILTER: " + this.selectedMultiple[index].text);
        value.push(this.selectedMultiple[index].text);
      }
      // Then updating form
      let key = this.entity + this.cf_type + lookup;

      // let value = this.selectedMultiple;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
    },
    discardClickedExact: function () {
      this.selected = "";
      this.min_selected = 1;
      this.max_selected = 1000;
      this.selectedMultiple = [];

      var key_to_delete = this.entity + this.cf_type + "__range";
      this.cleanKey(key_to_delete);
      var lookup = this.checkbox ? "__not_in" : "__in";
      key_to_delete = this.entity + this.cf_type + lookup;
      // console.log("Deleting: " + key_to_delete);
      this.cleanKey(key_to_delete);

      let key = this.entity + this.cf_type;
      let value = this.selected;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
    },
    discardClickedRange: function () {
      this.min_selected = 1;
      this.max_selected = 1000;
      let key = this.entity + this.cf_type + "__range";
      let value = [this.min_selected || 1, this.max_selected || 1000];
      // console.log("Selected: " + value);
      this.selected = "";

      let key_to_delete = this.entity + this.cf_type;
      // console.log("Key to delete:" + key_to_delete);
      this.cleanKey(key_to_delete);
      this.updateForm(key, value);
    },
    discardClickedMultiple: function () {
      this.discardClickedExact();
      this.discardClickedRange();
      this.selectedMultiple = [];
      var lookup = this.checkbox ? "__not_in" : "__in";
      var negative_lookup = lookup == "__not_in" ? "__in" : "__not_in";
      var key_to_delete = this.entity + this.cf_type + negative_lookup;
      // console.log("Key to delete:" + key_to_delete);
      this.cleanKey(key_to_delete);
      key_to_delete = this.entity + this.cf_type;
      this.cleanKey(key_to_delete);
      // console.log("Selected: " + JSON.stringify(this.selectedMultiple));
      var value = [];
      for (const index in this.selectedMultiple) {
        // console.log("FILTER: " + this.selectedMultiple[index].text);
        value.push(this.selectedMultiple[index].text);
      }
      // Then updating form
      let key = this.entity + this.cf_type + lookup;

      // let value = this.selectedMultiple;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
    },

    cleanKey: function (key_to_delete) {
      this.deleteFilterKey({ key_to_delete });
    },
    updateForm: function (key, value) {
      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },

    findValueByPrefix: function (object, prefix) {
      for (var property in object) {
        if (
          Object.prototype.hasOwnProperty.call(object, property) &&
          property.toString().startsWith(prefix)
        ) {
          return [property, object[property]];
        }
      }
    },
  },

  created() {
    // console.log("Entity + name = " + this.entity + this.cf_type);
    let prefix = this.entity + this.cf_type;
    let settings = this.getSettings().filters;
    let result = this.findValueByPrefix(settings, prefix);
    if (!result) {
      return;
    }
    let key = result[0];
    let value = result[1];
    // console.log("KEY: " + key + " VALUE: " + value);
    if (key.includes("in")) {
      // console.log("Includes IN");
      this.selectedMultiple = value;
      // console.log("Selected multiple: " + this.selectedMultiple);
    } else if (key.includes("range")) {
      this.min_selected = value[0];
      this.max_selected = value[1];
    } else {
      this.selected = value;
    }
    if (key.includes("not")) {
      this.checkbox = true;
    }
    // this.selected = this.getSettings().filters[this.entity + this.name];
    // this.selectedMultiple = this.getSettings().filters[this.entity + this.name];
  },
};
</script>

<style scoped>
.v-application .error--text {
  color: #ccc !important;
}
</style>
